export default __webpack_public_path__ + "img/jkXTYkaF.c35bd641.svg";